<template>
  <div class="payment-box">
    <div class="payment-top">
      <div class="waiting-text"><img src="../../assets/index/clock_icon.png" alt=""> 等待付款</div>
      <div class="order-price">还需支付{{price}}元</div>
      <div class="order-time">请在&nbsp;&nbsp;<span class="time-style">30分钟</span>&nbsp;&nbsp;内完成支付</div>
    </div>
    <div class="payment-type">支付方式</div>
    <div class="wx-pay" v-if="isWx" @click="wxPayEvent();return false"><img src="../../assets/index/wx_icon.png" alt=""> 微信支付</div>
    <div class="wx-pay" v-else @click="wxPayEvent"><img src="../../assets/index/wx_icon.png" alt=""> 微信支付</div>
    <!-- <div class="ali-pay" @click="aliPayEvent"><img src="../../assets/index/ali_icon.png" alt=""> 支付宝支付</div> -->
    <div class="goback-page" @click="$router.push('/myorders/0')">
      <!-- <van-icon name="arrow-left" /> -->
    </div>
  </div>

</template>

<script>
import { webPay, aliPay, wxPayJsPay, findWxOrderStatus } from "@/api/index";
import { Dialog } from "vant";

export default {
  name: "payment",

  data() {
    return {
      orderId: this.$route.query.orderId,
      price: this.$route.query.price || localStorage.getItem("orderPrice"),
      canSet: false,
      isWx: false,
    };
  },
  mounted() {
    let ua = navigator.userAgent.toLowerCase(); // 获取判断用的对象
    if (ua.indexOf("micromessenger") >= 0) {
      this.isWx = true;
    }
  },

  methods: {
    aliPayEvent() {
      localStorage.setItem("paynum", this.orderId);
      localStorage.setItem("paytype", "ali");
      localStorage.setItem("orderPrice", this.$route.query.price);
      let ua = navigator.userAgent.toLowerCase(); // 获取判断用的对象
      if (ua.indexOf("micromessenger") >= 0) {
        wxPayJsPay(this.orderId).then((res) => {
          console.log(res);
        });
      } else {
        aliPay(this.orderId).then((res) => {
          console.log(res);
          // this.$store.state.user.payUrl = res.info
          // Vue中使用支付宝支付流程:点击支付宝支付调用后台接口，后台会返回一个form表单，只要在Vue里面创建新节点提交就可以唤起支付宝支付了
          const div = document.createElement("div");
          div.innerHTML = res.data; // 此处就是后台返回接到from表单的数据
          document.body.appendChild(div);
          document.forms[0].submit();
        });
      }
    },

    wxPayEvent() {
      localStorage.setItem("paynum", this.orderId);
      localStorage.setItem("paytype", "wx");
      localStorage.setItem("orderPrice", this.$route.query.price);

      let ua = navigator.userAgent.toLowerCase(); // 获取判断用的对象
      if (ua.indexOf("micromessenger") >= 0) {
        findWxOrderStatus(this.orderId).then((res) => {
          if (res.data.data.code == "1") {
            Dialog.confirm({
              title: "提示",
              message: "已经支付成功哦",
            })
              .then(() => {
                // on confirm
                this.$router.push({
                  path: "/myorders/0",
                });
              })
              .catch(() => {
                // on cancel
                this.$router.push({
                  path: "/myorders/0",
                });
              });
            localStorage.removeItem("paynum");
            localStorage.removeItem("paytype");
            return;
          } else {
            wxPayJsPay(this.orderId).then((res) => {
              console.log(res);
              window.WeixinJSBridge.invoke(
                "getBrandWCPayRequest",
                {
                  appId: res.data.data.appId, //公众号名称，由商户传入
                  timeStamp: res.data.data.timeStamp, //时间戳，自1970年以来的秒数
                  nonceStr: res.data.data.nonceStr, //随机串
                  package: res.data.data.package,
                  signType: res.data.data.signType, //微信签名方式：
                  paySign: res.data.data.paySign, //微信签名
                },
                (res) => {
                  if (res.err_msg == "get_brand_wcpay_request:ok") {
                    // 使用以上方式判断前端返回,微信团队郑重提示：
                    //res.err_msg将在用付成户支功后返回ok，但并不保证它绝对可靠。
                    this.$router.push("/myorders/0");
                  } else {
                    alert("支付失败");
                  }
                }
              );
            });
          }
        });
      } else {
        findWxOrderStatus(this.orderId).then((res) => {
          if (res.data.data.code == "1") {
            Dialog.confirm({
              title: "提示",
              message: "已经支付成功哦",
            })
              .then(() => {
                // on confirm
                this.$router.push({
                  path: "/myorders/0",
                });
              })
              .catch(() => {
                // on cancel
                this.$router.push({
                  path: "/myorders/0",
                });
              });
            localStorage.removeItem("paynum");
            localStorage.removeItem("paytype");
            return;
          } else {
            webPay(this.orderId).then((result) => {
              console.log(result);
              if (result.data.errno == 0) {
                this.canSet = true;

                window.location.replace(
                  result.data.data.mweb_url +
                    "&redirect_url=" +
                    "http%3a%2f%2fcruitaly.cafewallet.cn%2f%23%2ftype%2fresult%3fordertype%3dwx"
                );
              } else {
                Dialog.alert({
                  title: "提示",
                  message: result.data.errmsg,
                });
              }
            });
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.goback-page {
  position: fixed;
  top: 0;
  left: 2rem;
  z-index: 4;
  height: 6rem;
  width: 5rem;
  display: flex;
  align-items: center;
  font-size: 2.3rem;
}
.payment-box {
  height: 100%;
  /*控制底部滚动*/
  overflow-y: scroll;

  .payment-top {
    height: 14.6rem;
    background: url("../../assets/index/payment_top.png") top left no-repeat;
    background-size: 100%;
    padding-top: 3.89rem;
    box-sizing: border-box;
    .waiting-text {
      font-family: PingFangSC-Semibold;
      font-size: 2em;
      color: #424242;
      letter-spacing: 0;
      line-height: 2em;
      display: flex;
      align-items: center;
      padding-left: 2rem;
      box-sizing: border-box;
      img {
        height: 2.3rem;
        width: 2.3rem;
      }
    }
    .order-price {
      font-family: PingFangSC-Regular;
      font-size: 1.4em;
      color: #424242;
      letter-spacing: 0;
      text-align: center;
      line-height: 1.4em;
      margin: 0.7rem 0 4rem;
      text-align: left;
      padding-left: 2rem;
    }
    .order-time {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #424242;
      letter-spacing: 0;
      line-height: 1.4em;
      text-align: left;
      padding-left: 2.2rem;
      .time-style {
        font-family: PingFangSC-Semibold;
        font-size: 12px;
        color: #000000;
        letter-spacing: 0;
        line-height: 1.4em;
      }
    }
  }
  .payment-type {
    height: 4.4rem;
    background: #fff;
    font-family: PingFangSC-Semibold;
    font-size: 1.6em;
    color: #424242;
    letter-spacing: 0;
    line-height: 4.4rem;
    text-align: left;
    padding-left: 1.6rem;
    border-bottom: 1px solid #f5f5f5;
  }
  .wx-pay {
    height: 4.4rem;
    font-family: PingFangSC-Regular;
    font-size: 1.4em;
    color: #424242;
    letter-spacing: 0;
    line-height: 1.4em;
    display: flex;
    align-items: center;
    margin-left: 1.6rem;
    border-bottom: 1px solid #f5f5f5;
    img {
      height: 2rem;
      width: 2rem;
      margin: 0 0.6rem 0 0;
    }
  }
  .ali-pay {
    height: 4.4rem;
    font-family: PingFangSC-Regular;
    font-size: 1.4em;
    color: #424242;
    letter-spacing: 0;
    line-height: 1.4em;
    display: flex;
    align-items: center;
    margin-left: 1.6rem;
    border-bottom: 1px solid #f5f5f5;
    img {
      height: 2rem;
      width: 2rem;
      margin: 0 0.6rem 0 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/type/payment.vue